module.exports = __webpack_public_path__ + "media/images/story/top/rosemary-8b3b298099d2b4434cfc44db22ee64b9.png";